export const lettersAndSpaces = /^[a-zA-Z\s'’]*$/;
